import { Toaster as SonnerToaster } from 'sonner'

/**
 * Toast-container. Placeres én gang i rodkomponenten.
 *
 * `richColors` er bevidst slået fra: vi styrer farverne gennem vores egne
 * tokens, og Sonners standardpalette ville bryde med resten af UI'et.
 *
 * Selve `toast`-funktionerne ligger i `toast.ts`.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={5000}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group border border-line-strong bg-app-850/95 text-text-primary shadow-[var(--shadow-panel)] backdrop-blur-xl rounded-[var(--radius-card)]',
          title: 'text-sm font-medium',
          description: 'text-[13px] text-text-secondary',
          actionButton: 'bg-brand-500 text-white',
          cancelButton: 'bg-white/10 text-text-secondary',
          success: '[&_[data-icon]]:text-success-400',
          error: '[&_[data-icon]]:text-danger-400',
          warning: '[&_[data-icon]]:text-warning-400',
          info: '[&_[data-icon]]:text-info-400',
        },
      }}
    />
  )
}
